import { render, staticRenderFns } from "./portfolio.vue?vue&type=template&id=4883eff0&scoped=true&"
import script from "./portfolio.vue?vue&type=script&lang=js&"
export * from "./portfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4883eff0",
  null
  
)

export default component.exports